module.exports = __webpack_public_path__ + "img/10.0b28986.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/10.jpg
// module id = 202
// module chunks = 1